module.exports = __webpack_public_path__ + "img/swing_left_door.d696bfa2.png";